import { H3 } from '../Headings';

export const StyledCardTitle = H3;
